import React from 'react'
import PropTypes from 'prop-types';
import { BooleanCreator, Icons } from '@leverege/api-attributes';

import { ValueCard } from '~/views';

export default class BooleanViewer extends React.Component {

  static TYPE = BooleanCreator.typeName();

  static propTypes = {
    device : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object
  }

  render() {
    const { attribute : attr, name, onClick, editable, value } = this.props
    if ( attr == null ) {
      return <div />
    }

    const val = value === true ? checkTrim( attr.trueDisplayValue, 'On' ) :
      value === false ? checkTrim( attr.falseDisplayValue, 'Off' ) :
        checkTrim( attr.unsetDisplayValue, null )
    const icon = Icons.getIcon( attr )
    return (
      <ValueCard name={name || attr.name} editable={editable} value={val} icon={icon} onClick={onClick} />
    )
  }

}

function checkTrim( v, dVal ) {
  if ( v == null ) {
    return dVal
  }
  if ( typeof v === 'string' && v.trim().length == 0 ) {
    return dVal
  }
  return v
}
